const drawerWidth = 200;

export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    [theme.breakpoints.up(960)]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  toolbar: {
    left: 0,
    width: drawerWidth,
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    backgroundColor: "#eeeeee",
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  headerText: {
    textAlign: "center",
  },
  theme: {
    direction: "rtl1",
  },
});
